import { ButtonV2 } from 'libs/growth-platform-brand-system-v2/src/components/ButtonV2';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { createSchema, morphism } from 'morphism';
import React from 'react';
import { TestimonialSectionProps } from '../../components/TestimonialSection';
import { schemaCard } from '../components/schemaCard';
import {
  filterIsSelfServeButMobile,
  schemaDatoButton,
} from '../schemaDatoButton';

export const schemaTestimonialSection = createSchema<
  TestimonialSectionProps,
  any
>({
  type: 'testimonialType',
  title: 'title',
  subtitle: 'subtitle',
  buttons: {
    path: ['button', 'section', 'locale'],
    fn: ({
      button,
      section,
      locale,
    }: {
      button: any[];
      section: any;
      locale: string;
    }) => {
      if (button) {
        let _button = filterIsSelfServeButMobile(button);
        _button = _button.map((btn) =>
          morphism(schemaDatoButton, { ...btn, locale }),
        );
        return _button?.map((btn: any, key: number) => (
          <ButtonTracking
            component={ButtonV2}
            {...btn}
            key={key}
            section={section}
            index={key}
            labelTracking={btn.title}
          />
        ));
      }
      return [];
    },
  },
  isDark: 'isDark',
  backgroundColor: 'backgroundColor',
  cardsBackgroundColor: 'cardsBackgroundColor',
  content: {
    path: ['content', 'section', 'testimonialType'],
    fn: ({ content, section }: any) => {
      const _content = content.map((card: any, index: number) => ({
        ...card,
        section,
        index,
      }));
      const cards = morphism(schemaCard, _content);

      const mapCards = (card: any) => {
        if (card?.ctaButton) {
          const { ctaButton, ...cardProps } = card;
          const {
            as,
            href,
            to,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            component,
            onClick,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            tabIndex,
            role,
            rel,
            section,
            index,
            labelTracking,
            ...ctaProps
          } = ctaButton.props;

          return {
            ...cardProps,
            className: 'cursor-pointer',
            as: ButtonTracking,
            component: as,
            section,
            index,
            href,
            to,
            onClick,
            role,
            rel,
            labelTracking:
              card?.title ||
              card?.subtitle ||
              card?.text ||
              card?.image?.props?.alt ||
              labelTracking,
            ctaButton: (
              <ButtonV2
                {...ctaProps}
                as="span"
                className="mt-[20px] self-start"
              />
            ),
          };
        }
        return card;
      };
      if (Array.isArray(cards)) {
        return cards?.map((card) => {
          return mapCards(card);
        });
      }
      return mapCards(cards);
    },
  },
  isAutoplay: 'isAutoplay',
});
